import { FormattedMessage } from 'react-intl';
import React from 'react';

import { Schema } from 'src/utils/form';

export default Schema.object({
  idIntegracao: Schema.string().label(<FormattedMessage id="idIntegracao" />),
  descricao: Schema.string().label(<FormattedMessage id="descricao" />),
});
